import React from 'react';
import styles from './MainBlock.module.css';
import mainImg from '../../assets/img/mainImg.webp';

export default function MainBlock({ dataInfo }) {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.content_block}>
          <div className={styles.title}>Я СТРУНКА</div>
          <h1 className={styles.subTitle}>Онлайн-програма здорового схуднення та корекції ваги</h1>
          <div className={styles.text}>
            Долучайся до програми, яка вже змінила життя сотням жінок
          </div>
          <div className={styles.text_start}>Спробуй п'ять днів безкоштовно!</div>
          <div className={styles.text_start}>Старт: {dataInfo.startDateGroup}</div>
        </div>
        <a
          href={dataInfo.telegtamGropLink}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.start_group_btn + ' ' + 'hover activeClick'}>
          Приєднатись до групи
        </a>
        <img className={styles.mainImg} src={mainImg} />
      </div>
    </>
  );
}
